<template>
  <div class="flex flex-col xl:flex-row xl:px-6 xl:py-3 bg-white text-left text-sm text-gray items-center hover:bg-gray-100 border border-gray-200 xl:border-b xl:border-gray-50 xl:border-l-0 xl:border-t-0 xl:border-r-0 xl:space-x-10">
    <div class="flex flex-row w-full items-center xl:w-auto border-b border-gray-200 xl:border-0 bg-gray-100 xl:bg-transparent">
      <div class="xl:hidden flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 flex-1 text-center text-gray-500 font-medium">
        Avatar
      </div>
      <div class="flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 bg-gray-25 xl:bg-transparent text-gray-500 text-left">
<!--        <img class="inline-block h-16 w-16 rounded-full" src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="">-->
        <img class="inline-block h-16 w-16 rounded-full" :src="representative.gravatar" alt="">
      </div>
    </div>
    <div class="flex flex-row w-full xl:w-3/12 border-b border-gray-200 xl:border-0 bg-gray-100 xl:bg-transparent">
      <div class="xl:hidden flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 flex-1 text-center text-gray-500 font-medium">
        Name
      </div>
      <div class="flex xl:flex-col items-center xl:items-start justify-center xl:justify-start xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 bg-gray-25 xl:bg-transparent text-gray-500 text-left xl:font-medium xl:text-base">
        <div class="flex flex-col space-y-3">
          {{ representative.name }}
          <span class="hidden xl:block font-normal text-sm">{{ representative.title }}</span>
          <div class="hidden xl:block font-normal flex flex-col justify-between text-sm">
            <div>
              <a  :href="representative.calendly_link" target="_blank"  class="flex items-center text-pink hover:text-pink-700">
                <i class="fas fa-link inline-block mr-2"></i>
                View Calendly
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="xl:hidden flex flex-row w-full items-center xl:w-3/12 border-b border-gray-200 xl:border-0 bg-gray-100 xl:bg-transparent">
      <div class="xl:hidden flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 flex-1 text-center text-gray-500 font-medium">
        Title
      </div>
      <div class="flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 bg-gray-25 xl:bg-transparent text-gray-500 text-left">
        {{ representative.title }}
      </div>
    </div>
    <div class="flex flex-row w-full items-center xl:w-4/12 border-b border-gray-200 xl:border-0 bg-gray-100 xl:bg-transparent">
      <div class="xl:hidden flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 flex-1 text-center text-gray-500 font-medium">
        State
      </div>
      <div class="flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 bg-gray-25 xl:bg-transparent text-gray-500 text-left">
        {{ representative.selectedStatesString }}
      </div>
    </div>
    <div class="xl:hidden flex flex-row w-full items-center xl:w-1/12 border-b border-gray-200 xl:border-0 bg-gray-100 xl:bg-transparent">
      <div class="xl:hidden flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 flex-1 text-center text-gray-500 font-medium">
        Calendly
      </div>
      <div class="flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 bg-gray-25 xl:bg-transparent text-gray-500 text-left">
        <a :href="representative.calendly_link" target="_blank" class="flex items-center text-pink hover:text-pink-700">
          <i class="fas fa-link inline-block mr-2"></i>
          View Calendly
        </a>
      </div>
    </div>
    <div class="xl:ml-auto flex flex-row w-full items-center xl:w-auto bg-gray-100 xl:bg-transparent flex-grow w-auto">
      <a :href='editUrl()' class="hidden ml-auto xl:inline-flex items-center px-6 py-3 border border-transparent text-base font-medium shadow-sm text-white bg-pink-500 hover:bg-pink-700 focus:outline-none focus:outline-none  focus:ring-pink-200">
        Edit
      </a>
      <div class="xl:hidden flex items-center justify-center xl:justify-start w-1/2 xl:w-full px-6 py-3 xl:px-0 xl:py-0 flex-1 text-center text-gray-500 font-medium">
        Actions
      </div>
      <div class="xl:hidden flex items-center justify-center xl:justify-start w-1/2 xl:w-auto px-6 py-3 xl:px-0 xl:py-0 bg-gray-25 xl:bg-transparent text-center text-gray-500">
        <representative-crud-button :representative="representative"/>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      representative: null,
    },
    data() {
      return {
        isOpen: false,
      }
    },
    methods: {
      delete(id) {

        axios.post('/admin/representatives/'+id+'/delete', {_method: 'DELETE',})
            .then(response => {
              this.$notify({
                text: 'Representative deleted successfully',
                type: 'success',
              })

              window.location.href = '/admin/representatives'
            })
      },
      editUrl() {
        return '/admin/representatives/'+this.representative.id+'/edit'
      },
    },
  }
</script>
